import React from "react";
import { useTable, useSortBy, usePagination } from "react-table";
import { Link } from "react-router-dom";
import SearchInput from "./SearchInput";
import CustomSelect from "./CustomSelect";

const MyTable = ({
  columns,
  data,
  filterInput,
  handleFilterChange,
  type,
  onRowClick,
  rowClassName,
  onBillClick,
  showPagination = true,
}) => {
  const filteredData = React.useMemo(() => {
    if (!filterInput) {
      return data;
    }
    return data.filter((row) => {
      const values = Object.values(row);
      return values.some((value) =>
        value !== null && value !== undefined
          ? value.toString().toLowerCase().includes(filterInput.toLowerCase())
          : false
      );
    });
  }, [data, filterInput]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    setPageSize,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns,
      data: filteredData,
      initialState: { pageIndex: 0, pageSize: 50 },
    },
    useSortBy,
    usePagination
  );

  const pageSizeOptions = [50, 100].map((pageSize) => ({
    value: pageSize,
    label: `Show ${pageSize}`,
  }));

  return (
    <>
      <div className="overflow-x-auto">
        <table {...getTableProps()} className="w-full whitespace-nowrap   ">
          <thead>
            {headerGroups.map((headerGroup) => (
              <tr
                {...headerGroup.getHeaderGroupProps()}
                className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b bg-gray-50"
              >
                {headerGroup.headers.map((column) => (
                  <th
                    {...column.getHeaderProps(column.getSortByToggleProps())}
                    className={`px-4 py-3 ${column.className || ""}`}
                  >
                    {column.render("Header")}
                    <span>
                      {column.isSorted
                        ? column.isSortedDesc
                          ? " 🔽"
                          : " 🔼"
                        : ""}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody
            {...getTableBodyProps()}
            className="bg-white divide-y divide-gray-100"
          >
            {page.map((row) => {
              prepareRow(row);
              return (
                <tr
                  {...row.getRowProps()}
                  className={`text-gray-700 ${rowClassName}`}
                >
                  {row.cells.map((cell) => (
                    <td {...cell.getCellProps()} className={`px-4 py-3 ${cell.column.className || ""}`}>
                      {cell.render("Cell")}
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <div
        className={`flex justify-between items-center p-4 py-1 mt-2 ${
          showPagination ? "" : "hidden"
        }`}
      >
        <span className="text-sm">
          Showing{" "}
          <strong>
            {pageIndex + 1} to {pageOptions.length}
          </strong>{" "}
          Pages
        </span>

        {/* <select
          value={pageSize}
          onChange={(e) => {
            setPageSize(Number(e.target.value));
          }}
        >
          {[5, 10, 20, 30, 40].map((pageSize) => (
            <option key={pageSize} value={pageSize}>
              Show {pageSize}
            </option>
          ))}
        </select> */}

        <div className=" paginationSelect">
          <CustomSelect
            value={pageSize}
            onChange={(selectedOption) => {
              setPageSize(Number(selectedOption.value));
            }}
            options={pageSizeOptions}
            isSearchable={false}
            placeholder="Select Page Size"
            isClearable={false}
            isDisabled={false}
            className="w-[130px]"
          />
        </div>

        <span
          className={`text-sm inline-flex rounded-md overflow-hidden ${
            showPagination ? "" : "hidden"
          }`}
        >
          <button
            className={`p-2 inline-flex rounded-none px-3 ${
              canPreviousPage
                ? "bg-gray-300 text-gray-600"
                : "bg-gray-300 text-gray-600 opacity-50"
            }`}
            onClick={() => previousPage()}
            disabled={!canPreviousPage}
          >
            Previous
          </button>
          <span className="p-2 inline-flex px-3 bg-blue-700 text-white">
            {pageIndex + 1}
          </span>
          <button
            className={`p-2 inline-flex rounded-none px-3 ${
              canNextPage
                ? "bg-gray-300 text-gray-600"
                : "bg-gray-300 text-gray-600 opacity-50"
            }`}
            onClick={() => nextPage()}
            disabled={!canNextPage}
          >
            Next
          </button>
        </span>
      </div>
    </>
  );
};

export default MyTable;
